import formattedMessage from './languageModule'

export const otpErrorMapping = {
  WRONG: {
    label: formattedMessage.wrongCode
  },
  WRONG_DOUBLE: {
    label: formattedMessage.wrongDoubleCode
  },
  LAST: {
    label: formattedMessage.lastAttemptAvailable
  },
  LAST_DOUBLE: {
    label: formattedMessage.lastAttemptAvailableDouble
  },
  NEW: {
    label: formattedMessage.newOtpGenerated
  },
  NEW_DOUBLE: {
    label: formattedMessage.newDoubleOtpGenerated
  }
}
